<h4>{{ 'PUNCHOUT' | translate }}</h4>
<hr />

<lib-gung-tabset [activeId]="activeTabId" [destroyOnHide]="false" (tabChange)="onTabChange($event)">
  <lib-gung-tab id="configuration">
    <ng-template libGungTabTitle>
      <span>{{ 'PUNCHOUT_CONFIGURATION' | translate }}</span>
    </ng-template>
    <ng-template libGungTabContent>
      <lib-gung-settings-punchout-configs></lib-gung-settings-punchout-configs>
    </ng-template>
  </lib-gung-tab>

  <lib-gung-tab id="cart-transfers">
    <ng-template libGungTabTitle>
      <span>{{ 'PUNCHOUT_CART_TRANSFERS' | translate }}</span>
    </ng-template>
    <ng-template libGungTabContent>
      <lib-gung-settings-punchout-cart-transfers></lib-gung-settings-punchout-cart-transfers>
    </ng-template>
  </lib-gung-tab>

  <lib-gung-tab id="order-requests">
    <ng-template libGungTabTitle>
      <span>{{ 'PUNCHOUT_ORDER_REQUESTS' | translate }}</span>
    </ng-template>
    <ng-template libGungTabContent>
      <lib-gung-settings-punchout-order-requests></lib-gung-settings-punchout-order-requests>
    </ng-template>
  </lib-gung-tab>
</lib-gung-tabset>
